/* tslint:disable */
/* eslint-disable */
/**
 * referral-network
 * referral-network
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ListDirectoryContactsResponse } from './ListDirectoryContactsResponse';
import {
    ListDirectoryContactsResponseFromJSON,
    ListDirectoryContactsResponseFromJSONTyped,
    ListDirectoryContactsResponseToJSON,
} from './ListDirectoryContactsResponse';

/**
 * 
 * @export
 * @interface ListDirectoryContacts200Response
 */
export interface ListDirectoryContacts200Response {
    /**
     * 
     * @type {ListDirectoryContactsResponse}
     * @memberof ListDirectoryContacts200Response
     */
    data?: ListDirectoryContactsResponse;
}

/**
 * Check if a given object implements the ListDirectoryContacts200Response interface.
 */
export function instanceOfListDirectoryContacts200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ListDirectoryContacts200ResponseFromJSON(json: any): ListDirectoryContacts200Response {
    return ListDirectoryContacts200ResponseFromJSONTyped(json, false);
}

export function ListDirectoryContacts200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListDirectoryContacts200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ListDirectoryContactsResponseFromJSON(json['data']),
    };
}

export function ListDirectoryContacts200ResponseToJSON(value?: ListDirectoryContacts200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': ListDirectoryContactsResponseToJSON(value.data),
    };
}

